module.exports = __webpack_public_path__ + "img/冰淇淋车.c7af29d0.png";